import React, { Component } from 'react'
import { getTermEndMonth, i18nTranslate } from 'src/utils'
import { Button, Modal } from 'react-bootstrap'
import parse from 'html-react-parser'
import './styles.scss'
import { dateFormatDeps } from 'src/deps'

class NotificationPopUp extends Component {
  constructor(props) {
    super(props)
  }
  UTCdate = true
  // Method to calculate monthString based on termDate
  getMonthString(termDate) {
    const defaultMonthString = ''
    if (termDate !== undefined && termDate !== null && termDate !== '') {
      const date = new Date(termDate)
      if (!isNaN(date.getTime())) {
        date.setMonth(date.getMonth() + 2)
        const termEndDate = date.toISOString().split('.')[0]
        const finalDate = dateFormatDeps?.getMonthInString(
          termEndDate,
          this.UTCdate
        )
        return finalDate?.split(' ')[0]
      }
    }
    return defaultMonthString
  }

  render() {
    const {
      isToShowPopUp = true,
      handleCloseNotificationPopup,
      handleShowWarningPopupModal,
      handleKeepMeBrandAffiliate,
      termDate,
    } = this.props

    if (!isToShowPopUp) {
      return null
    }

    // Get the month string using the method
    const monthString = this.getMonthString(termDate)

    return (
      <Modal
        show={isToShowPopUp}
        className="conversion-success-modal rounded-md">
        <Modal.Body className="conversion-success-modal">
          <h4 className="conversion-success-modal-title">
            {i18nTranslate(
              'ba_to_member_keep_your_benefits',
              'Switch your account to keep your benefits!'
            )}
          </h4>
          <p className="conversion-success-modal-message mt-4">
            {i18nTranslate(
              'ba_to_member_account_deletion_warning',
              'Your account is in danger of being deleted.'
            )}
          </p>
          <p className="conversion-success-modal-message font-weight-bold">
            {i18nTranslate(
              'ba_to_member_dc_sv_completion_warning',
              'To avoid deletion, complete your 50 DC-SV requirement by the end of [month].'
            )?.replace('{month}', monthString)}
          </p>
          <p className="conversion-success-modal-message">
            {parse(
              i18nTranslate(
                'ba_to_member_account_switch_explanation',
                'If you no longer want to participate as a Brand Affiliate but <strong>want access to wholesale pricing and loyalty rewards, you can switch to a Member Account</strong> by clicking the "Switch to Member" option below.'
              )
            )}
          </p>
          <div className="row">
            <div className="col-12">
              <Button
                data-testid="qa-acknowledgeButton"
                className="acknowledge-button rounded-md"
                variant="primary"
                type="submit"
                onClick={handleShowWarningPopupModal}
                block>
                {i18nTranslate(
                  'ba_to_member_switch_to_member_button',
                  'Switch to Member'
                )}
              </Button>
            </div>
            <div className="col-12">
              <Button
                className="acknowledge-button rounded-md"
                variant="outline-primary"
                data-testid="qa-exit-cancel-button"
                block
                onClick={handleCloseNotificationPopup}
                tabIndex={0}>
                {i18nTranslate(
                  'ba_to_member_reminder_action',
                  'Remind me next time'
                )}
              </Button>
            </div>
            <div
              className="keep-me-brand-affiliate col-12 mt-2 text-center font-weight-bold"
              onClick={handleKeepMeBrandAffiliate}
              tabIndex={0}>
              {i18nTranslate(
                'ba_to_member_keep_brand_affiliate',
                `Got it, I don't need a reminder`
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

export default NotificationPopUp
export { NotificationPopUp }
